import _styled, { default as _styled2, default as _styled3 } from "styled-components";
var _class, _Description, _templateObject, _templateObject2;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import "core-js/modules/es.symbol.description.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { Component, Fragment } from "react";
import { Trans, withTranslation } from "react-i18next";
import defined from "terriajs-cesium/Source/Core/defined";
import Box from "../../Styled/Box";
import Button from "../../Styled/Button";
import Collapsible from "../Custom/Collapsible/Collapsible";
import parseCustomMarkdownToReact from "../Custom/parseCustomMarkdownToReact";
import DataPreviewSections from "./DataPreviewSections";
import ExportData from "./ExportData";
import Styles from "./mappable-preview.scss";
import MetadataTable from "./MetadataTable";
import WarningBox from "./WarningBox";

/**
 * CatalogItem description.
 */
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
let Description = observer(_class = (_Description = class Description extends Component {
  renderDescription(catalogItem) {
    if (catalogItem.type === "wms") {
      return /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsxs(Trans, {
          i18nKey: "description.wms",
          children: ["This is a", /*#__PURE__*/_jsx("a", {
            href: "https://en.wikipedia.org/wiki/Web_Map_Service",
            target: "_blank",
            rel: "noopener noreferrer",
            children: "WMS service"
          }), ", which generates map images on request. It can be used in GIS software with this URL:"]
        })
      }, "wms-description");
    } else if (catalogItem.type === "wfs") {
      return /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsxs(Trans, {
          i18nKey: "description.wfs",
          children: ["This is a", /*#__PURE__*/_jsx("a", {
            href: "https://en.wikipedia.org/wiki/Web_Feature_Service",
            target: "_blank",
            rel: "noopener noreferrer",
            children: "WFS service"
          }), ", which transfers raw spatial data on request. It can be used in GIS software with this URL:"]
        })
      }, "wfs-description");
    }
    return null;
  }
  render() {
    var _catalogItem$metadata, _catalogItem$dataUrls;
    const {
      t
    } = this.props;
    const catalogItem = this.props.item;

    // Make sure all data and metadata URLs have `url` set
    const metadataUrls = (_catalogItem$metadata = catalogItem.metadataUrls) === null || _catalogItem$metadata === void 0 ? void 0 : _catalogItem$metadata.filter(m => m.url);
    const dataUrls = (_catalogItem$dataUrls = catalogItem.dataUrls) === null || _catalogItem$dataUrls === void 0 ? void 0 : _catalogItem$dataUrls.filter(m => m.url);
    return /*#__PURE__*/_jsxs(_StyledDiv, {
      className: Styles.description,
      children: [catalogItem.isExperiencingIssues && /*#__PURE__*/_jsx(WarningBox, {
        children: t("preview.mayBeExperiencingIssues")
      }), catalogItem.description && catalogItem.description.length > 0 && /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("h4", {
          className: Styles.h4,
          children: t("description.name")
        }), parseCustomMarkdownToReact(catalogItem.description, {
          catalogItem: catalogItem
        })]
      }), catalogItem.hasLocalData && /*#__PURE__*/_jsx("p", {
        children: t("description.dataLocal")
      }), !catalogItem.hasLocalData && !catalogItem.hasDescription && !catalogItem.hideDefaultDescription && /*#__PURE__*/_jsx("p", {
        children: t("description.dataNotLocal")
      }), metadataUrls && metadataUrls.length > 0 && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("h4", {
          className: Styles.h4,
          children: t("description.metadataUrls")
        }), metadataUrls.map((metadataUrl, _i) => /*#__PURE__*/_jsx(Box, {
          paddedVertically: true,
          children: /*#__PURE__*/_jsxs(_StyledA, {
            href: metadataUrl.url,
            target: "_blank",
            rel: "noopener noreferrer",
            className: "".concat(Styles.link, " description-metadataUrls"),
            children: [metadataUrl.title && /*#__PURE__*/_jsx(Button, {
              primary: true,
              children: metadataUrl.title
            }), !metadataUrl.title ? metadataUrl.url : null]
          })
        }, metadataUrl.url))]
      }), /*#__PURE__*/_jsx(DataPreviewSections, {
        metadataItem: catalogItem
      }), catalogItem.dataCustodian && catalogItem.dataCustodian.length > 0 && /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("h4", {
          className: Styles.h4,
          children: t("description.dataCustodian")
        }), parseCustomMarkdownToReact(catalogItem.dataCustodian, {
          catalogItem: catalogItem
        })]
      }), !catalogItem.hideSource && /*#__PURE__*/_jsxs(_Fragment, {
        children: [catalogItem.url && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsxs("h4", {
            className: Styles.h4,
            children: [catalogItem.typeName, " URL"]
          }), this.renderDescription(catalogItem), this.props.printView ? /*#__PURE__*/_jsx("code", {
            children: catalogItem.url
          }) : /*#__PURE__*/_jsx("input", {
            readOnly: true,
            className: Styles.field,
            type: "text",
            value: catalogItem.url,
            onClick: e => e.target.select()
          }), catalogItem.type === "wms" || catalogItem.type === "esri-mapServer" && defined(catalogItem.layers) && /*#__PURE__*/_jsxs("p", {
            children: [t("description.layerName"), (catalogItem.layers || "").split(",").length > 1 ? "s" : "", ": ", catalogItem.layers]
          }, "wms-layers"), catalogItem.type === "wfs" && /*#__PURE__*/_jsxs("p", {
            children: [t("description.typeName"), (catalogItem.typeNames || "").split(",").length > 1 ? "s" : "", ": ", catalogItem.typeNames]
          }, "wfs-typeNames")]
        }), dataUrls && dataUrls.length > 0 && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("h4", {
            className: Styles.h4,
            children: t("description.dataUrl")
          }), dataUrls.map((dataUrl, _i) => {
            var _dataUrl$type, _dataUrl$type2, _dataUrl$type3, _dataUrl$type4;
            return (((_dataUrl$type = dataUrl.type) === null || _dataUrl$type === void 0 ? void 0 : _dataUrl$type.startsWith("wfs")) || ((_dataUrl$type2 = dataUrl.type) === null || _dataUrl$type2 === void 0 ? void 0 : _dataUrl$type2.startsWith("wcs"))) && /*#__PURE__*/_jsxs(Fragment, {
              children: [((_dataUrl$type3 = dataUrl.type) === null || _dataUrl$type3 === void 0 ? void 0 : _dataUrl$type3.startsWith("wfs")) && parseCustomMarkdownToReact(t("description.useLinkBelow", {
                link: "\n                          <a\n                            href=\"http://docs.geoserver.org/latest/en/user/services/wfs/reference.html\"\n                            target=\"_blank\"\n                            rel=\"noopener noreferrer\"\n                            key=\"wfs\"\n                          >\n                            Web Feature Service (WFS) documentation\n                          </a>\n                        "
              })), ((_dataUrl$type4 = dataUrl.type) === null || _dataUrl$type4 === void 0 ? void 0 : _dataUrl$type4.startsWith("wcs")) && parseCustomMarkdownToReact(t("description.useLinkBelow", {
                link: "\n                          <a\n                            href=\"http://docs.geoserver.org/latest/en/user/services/wcs/reference.html\"\n                            target=\"_blank\"\n                            rel=\"noopener noreferrer\"\n                            key=\"wms\"\n                          >\n                            Web Coverage Service (WCS) documentation\n                          </a>\n                        "
              })), /*#__PURE__*/_jsx(Box, {
                paddedVertically: true,
                children: /*#__PURE__*/_jsxs(_StyledA2, {
                  href: dataUrl.url,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  className: "".concat(Styles.link, " description-dataUrls"),
                  children: [dataUrl.title && /*#__PURE__*/_jsx(Button, {
                    primary: true,
                    children: dataUrl.title
                  }), !dataUrl.title ? dataUrl.url : null]
                })
              }, dataUrl.url), " "]
            }, dataUrl.url);
          })]
        }), !this.props.printView && defined(catalogItem.metadata) && /*#__PURE__*/_jsxs(_Fragment, {
          children: [defined(catalogItem.metadata.dataSourceMetadata) && catalogItem.metadata.dataSourceMetadata.items.length > 0 && /*#__PURE__*/_jsx("div", {
            className: Styles.metadata,
            children: /*#__PURE__*/_jsx(Collapsible, {
              title: t("description.dataSourceDetails"),
              isInverse: true,
              children: /*#__PURE__*/_jsx(MetadataTable, {
                metadataItem: catalogItem.metadata.dataSourceMetadata
              })
            })
          }), defined(catalogItem.metadata.dataSourceMetadata) && catalogItem.metadata.dataSourceMetadata.items.length > 0 && /*#__PURE__*/_jsx("div", {
            className: Styles.metadata,
            children: /*#__PURE__*/_jsx(Collapsible, {
              title: t("description.dataServiceDetails"),
              isInverse: true,
              children: /*#__PURE__*/_jsx(MetadataTable, {
                metadataItem: catalogItem.metadata.serviceMetadata
              })
            })
          })]
        })]
      }), !this.props.printView ? /*#__PURE__*/_jsx(ExportData, {
        item: catalogItem
      }) : null]
    });
  }
}, _defineProperty(_Description, "propTypes", {
  item: PropTypes.object.isRequired,
  printView: PropTypes.bool,
  t: PropTypes.func.isRequired
}), _Description)) || _class;
export default withTranslation()(Description);
var _StyledDiv = _styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n          a,\n          a:visited {\n            color: ", ";\n          }\n        "])), p => p.theme.colorPrimary);
var _StyledA = _styled2("a")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n                    color: ", ";\n                  "])), p => p.theme.colorPrimary);
var _StyledA2 = _styled3("a").withConfig({
  displayName: "Description___StyledA2",
  componentId: "sc-1qq4e0q-0"
})(["color:", ";"], p => p.theme.colorPrimary);